import { cn } from './cn.js';
export function Card({ className, ...p }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('rounded-lg border bg-white shadow-sm', className)} {...p} />;
}
export function CardHeader({
  className,
  title,
  description,
  actions,
}: {
  className?: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
}) {
  return (
    <div className={cn('flex items-start justify-between gap-4 border-b px-5 py-4', className)}>
      <div>
        <h3 className="text-sm font-semibold text-grey-900">{title}</h3>
        {description && <p className="mt-0.5 text-xs text-grey-500">{description}</p>}
      </div>
      {actions}
    </div>
  );
}
export function CardBody({ className, ...p }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('px-5 py-4', className)} {...p} />;
}
